export const iconFontAwesomeAlphabetN = (
	<i className="fa-solid fa-n"></i>
);
